import React from "react";

const QueriesManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50.161"
      height="50.161"
      viewBox="0 0 50.161 50.161"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="Path_1354"
            data-name="Path 1354"
            d="M139.21,146h50.161v50.161H139.21Z"
            fill={fill ? fill : "#ff7e7e"}
          />
        </clipPath>
      </defs>
      <g
        id="db63"
        transform="translate(-139.21 -146)"
        clipPath="url(#clip-path)"
      >
        <path
          id="Path_1353"
          data-name="Path 1353"
          d="M169.088,170.864v2.616a3.461,3.461,0,0,1-2.109,3.205,3.4,3.4,0,0,1-4.085-1.026l-2.556-3.082a1.566,1.566,0,0,0-2.771,1v12.646a3.344,3.344,0,0,0,3.335,3.335h.127a1.568,1.568,0,0,1,1.566,1.566v3.9a1.538,1.538,0,0,0,.947,1.438,1.474,1.474,0,0,0,1.811-.449l4.729-6.029a1.3,1.3,0,0,1,1.076-.427H185.98a3.345,3.345,0,0,0,3.335-3.335v-13.59a3.344,3.344,0,0,0-3.335-3.334H170.653a1.568,1.568,0,0,0-1.566,1.566Zm3.427-20.874v14.258a3.508,3.508,0,0,1-3.5,3.5h-.133a1.645,1.645,0,0,0-1.643,1.643v4.092a1.613,1.613,0,0,1-.993,1.509,1.548,1.548,0,0,1-1.9-.47l-4.961-6.325a1.368,1.368,0,0,0-1.129-.449H142.7a3.508,3.508,0,0,1-3.5-3.5V149.989a3.508,3.508,0,0,1,3.5-3.5h26.312a3.509,3.509,0,0,1,3.5,3.5Zm-19.173,8.587a3.343,3.343,0,0,1,.2-1.218,3.144,3.144,0,0,1,.533-.905,11.848,11.848,0,0,1,.865-.9c.226-.216.462-.437.674-.667a2.176,2.176,0,0,0,.331-.474,1.175,1.175,0,0,0,.127-.54c0-1.489-2.524-2.58-3.085.182a1.128,1.128,0,0,1-2.254-.044,3.576,3.576,0,0,1,.467-1.609,3.836,3.836,0,0,1,3.429-2.129,3.71,3.71,0,0,1,3.765,3.479,3.278,3.278,0,0,1-.27,1.365,3.75,3.75,0,0,1-.628.918c-.4.429-.834.846-1.257,1.257a4.567,4.567,0,0,0-.39.421,1.622,1.622,0,0,0-.206.316,1.565,1.565,0,0,0-.1.283,4.714,4.714,0,0,0-.021.8c.023.922-1.906,1.026-2.125.2a3.009,3.009,0,0,1-.053-.738Zm1.136,5.151a1.25,1.25,0,0,1-1.269-1.279,1.3,1.3,0,0,1,1.282-1.25,1.264,1.264,0,0,1-.013,2.528Zm12.6,14.489a2.342,2.342,0,1,1-2.343,2.342A2.342,2.342,0,0,1,167.077,178.217Zm9.046,2.342a2.342,2.342,0,1,1-2.342-2.342A2.342,2.342,0,0,1,176.123,180.559Zm6.7,0a2.342,2.342,0,1,1-2.342-2.342A2.342,2.342,0,0,1,182.827,180.559Z"
          transform="translate(0.003 -0.438)"
          fill={fill ? fill : "#ff7e7e"}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default QueriesManagementIcon;
